"use client";

import { css } from "styled-components";
import { getBorderRadius, getColor, getFont, positioningCSS } from "../components/utils";

type Props = {
  font?: string;
  color?: string;
};
export const markdownStyle = css<Props>`
  ${props => getFont(props.font, "gallery.regular", props)}
  color: ${props => getColor(props.color, "black")};
  > :first-child > :first-child {
    margin-top: 0;
  }

  > *:last-child > :last-child {
    margin-bottom: 0;
  }

  p {
    margin-top: 0;
    margin-bottom: 16px;

    code {
      background: ${getColor("grayLightest")};
      ${getFont("gallery.code", null)};
      border: 1px solid ${getColor("border")};
      border-radius: ${getBorderRadius("default")};
      ${positioningCSS({ px: "xs", py: "none" })}
    }
  }

  hr {
    border: none;
    border-top: 1px solid ${getColor("gray")};
    margin-top: 16px;
    margin-bottom: 16px;
  }

  ol,
  ul {
    ${props => getFont(props.font, "gallery.regular", props)}
    margin-bottom: 16px;
    padding-left: 28px;

    li {
      list-style: inherit;
    }

    li p {
      ${positioningCSS({ mb: "none" })};
    }
    ol,
    ul {
      ${positioningCSS({ mb: "none" })};
    }
  }

  ol {
    list-style: decimal outside;
    li {
      padding-left: 7px;
    }
  }

  ul {
    list-style: disc outside;
  }

  h1 {
    ${props => getFont(props.font, "gallery.h1", props)}
    ${positioningCSS({ my: "xs" })}
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    ${props => getFont(props.font, "gallery.h2", props)}
    ${positioningCSS({ my: "xs" })}
  }

  blockquote {
    ${positioningCSS({ pl: "l" })}
    border-left: 3px solid ${props => props.theme.primaryColor};
    color: ${getColor("grayDarkest")};
    font-size: 16px;
    line-height: 1.7;
    margin-bottom: 16px;

    p {
      ${positioningCSS({ mb: "s" })}
    }
  }

  a {
    color: ${props => props.theme.primaryColor || getColor("primary")};
    &:hover {
      color: ${props => props.theme.primaryColorDark || getColor("primaryDark")};
      text-decoration: underline;
    }
  }

  mark {
    border-radius: 2px;
    padding: 0 2px;
  }
`;
